import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { TokenService } from '../../services/token.service';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
  currentLanguage: string = 'en'; // Idioma predeterminado
  flagMap: { [key: string]: string } = {
    en: 'assets/images/flags/united-kingdom.png',
    es: 'assets/images/flags/spain.png',
    ca: 'assets/images/flags/catalonia.png',
  };

  constructor(private translate: TranslateService,
    private tokenService: TokenService
  ) {
    this.currentLanguage = this.translate.currentLang || this.translate.getDefaultLang();

  }

  // Cambiar el idioma de la aplicación
  changeLanguage(lang: string): void {
    this.currentLanguage = lang;
    this.translate.use(lang);
  }

  closeSession(): void {
    this.tokenService.clearTokenWithCookie();
  }


  validUserAuthentication(): boolean {
    return this.tokenService.isAuthenticate();
  }

}
